import { useEffect, useState } from 'preact/hooks';

// ↑ Top (Kristi, Oct 29; every long page since the check-up, Nov 2): once you've scrolled more than
// a screen, a pill at the right of the page's pinned bar on a laptop and iPad, and a round button
// just above the section bar on a phone (higher while Select several's bar shows). Put `<ToTop>`
// in the pinned bar and `<ToTop float>` at the page's end: each shows only where it belongs.

export const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

/** True once the page has scrolled more than a screen. */
export function useFar(): boolean {
  const [far, setFar] = useState(false);
  useEffect(() => {
    const on = () => setFar(window.scrollY > window.innerHeight);
    on();
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);
  return far;
}

export function ToTop({ wide, float, above, class: cls = '' }: { wide: boolean; float?: boolean; above?: boolean; class?: string }) {
  const far = useFar();
  if (!far || wide === Boolean(float)) return null;
  return float ? (
    <button type="button" class={`round-btn queue-totop-float${above ? ' above-bulk' : ''}`} aria-label="Back to the top" onClick={toTop}>
      ↑
    </button>
  ) : (
    <button type="button" class={`btn-secondary queue-totop${cls ? ` ${cls}` : ''}`} onClick={toTop}>
      ↑ Top
    </button>
  );
}
